import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { UiComponentLibraryModule } from '../_component-library/component-library.module'
import { SharedModule } from '../_shared/shared.module'
import { AboutComponent } from './about/about.component'
import { HomeComponent } from './home.component'
import { HomeRoutingModule } from './home.routing'

@NgModule({
  declarations: [HomeComponent, AboutComponent],
  imports: [CommonModule, SharedModule, HomeRoutingModule, UiComponentLibraryModule, FormsModule, ReactiveFormsModule],
  exports: [],
  providers: [],
})
export class HomeModule {}
